/**
 * An association holds one of two registration numbers, and they cannot be confused: a SIRET is
 * fourteen digits, an RNA is a W followed by nine. So a single field can be asked for and the value
 * stored in whichever one it is, rather than making every organization work out which box is theirs.
 */
export type OrganizationNumber = { SIRETNumber: string } | { RNANumber: string } | null

const SIRET = /^\d{14}$/
const RNA = /^W\d{9}$/

/** Digits grouped for readability and a lowercase w are both common; neither should be rejected. */
const normalize = (value: string): string => value.replace(/[\s.-]/g, '').toUpperCase()

export const parseOrganizationNumber = (value: string): OrganizationNumber => {
  const normalized = normalize(value)

  if (SIRET.test(normalized)) {
    return { SIRETNumber: normalized }
  }

  if (RNA.test(normalized)) {
    return { RNANumber: normalized }
  }

  return null
}

export const ORGANIZATION_NUMBER_ERROR =
  'Entrez un numéro SIRET (14 chiffres) ou un numéro RNA (W suivi de 9 chiffres).'
